"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PricesSection = require("./PricesSection");
Object.keys(_PricesSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PricesSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PricesSection[key];
    }
  });
});
